import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import EventGroupFields from './EventGroupFields'

export const EventGroupCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <EventGroupFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default EventGroupCreate
